import React, { useState } from 'react';
import { Container } from './components/Container';
import { DangerousHTML } from './components/DangerousHTML';
import { RedirectionButton } from './components/Button';
import { Facebook, Twitter } from './components/Icons';

const classNames = require('html-classnames');

const DistrictCard = ({ district }: any) => (
  <div className="districtCard">
    <h3>{district.label}</h3>
    <div className="districtCard__contact">
      <DangerousHTML
        element="div"
        html={district.address}
      />
      <div className="socialmedia">
        <ul>
          {district.twitter && (
            <li>
              <a href={district.twitter}>
                <Twitter />
                {' '}
                Twitter
              </a>
            </li>
          )}
          {district.facebook && (
            <li>
              <a href={district.facebook}>
                <Facebook />
                {' '}
                Facebook
              </a>
            </li>
          )}
          {district.email && <li><a href={`mailto:${district.email}`}>{district.email}</a></li>}
        </ul>
      </div>
    </div>
    {district.spokesperson_title ? (
      <>
        <h4>{district.spokesperson_title}</h4>
        <p>
          {district.spokesperson}
          ,
          {' '}
          <a href={`tel:${district.spokesperson_phone}`}>{district.spokesperson_phone}</a>
        </p>
      </>
    ) : null}

    <h4>Zarząd Okręgu</h4>
    <p>{district.board}</p>
  </div>
);

export const ContactContent: React.FC<any> = ({
  voivodeships, spokesperson, spokesperson_title, spokesperson_email, spokesperson_phone, address, phone, email, account_number, account_address,
}) => {
  const [activeTab, setActiveTab] = useState(voivodeships[0].label);

  const selectedVoivodeship = voivodeships.find((v: any) => v.label === activeTab);
  return (
    <main className="contact">
      <div className="contact__top_unit">
        <h2 className="contact__title">Kontakt</h2>
        <div className="contact__navigation">
          <RedirectionButton
            url="/filary"
            color="#8B235D"
            arrowColor="#FAFAFA"
            text="Filary naszej polityki"
          />
        </div>
      </div>
      <Container className="contact__text national_office">
        <h3>Biuro Krajowe</h3>
        <div className="contact_cards">
          <div className="contact_card">
            <div className="contact_card__text">
              <DangerousHTML
                element="div"
                html={address}
              />
              <p>
                tel:
                {' '}
                {phone && <a href={`tel:${phone}`}>{phone}</a>}
              </p>
              <p>
                email:
                {' '}
                {email && <a href={`mailto:${email}`}>{email}</a>}
              </p>
            </div>
          </div>

          <div className="contact_card">
            <div className="contact_card__text">
              <h4>{spokesperson_title}</h4>
              <p>{spokesperson}</p>
              <p>
                tel:
                {' '}
                {spokesperson_phone && <a href={`tel:${spokesperson_phone}`}>{spokesperson_phone}</a>}
              </p>
              <p>
                email:
                {' '}
                {spokesperson_email && <a href={`mailto:${spokesperson_email}`}>{spokesperson_email}</a>}
              </p>
            </div>
          </div>
        </div>
        <div className="contact__main-info">
          <h3>Konto Bankowe</h3>
          <p>{account_number}</p>
          <p>Lewica Razem</p>
          <p>{account_address}</p>
          <p>
            W tytule wpłat na realizację celów statutowych Razem prosimy o umieszczanie sformułowania "Darowizna na partię".
          </p>
        </div>
        <h3>Okręgi Razem</h3>
        <nav className="contact__tags">
          {voivodeships?.map((v:any) => (
            <li role="button" onClick={() => setActiveTab(v.label)} key={v.label} className={classNames('tab', { '--active': v.label == activeTab })}>{v.label}</li>))}
        </nav>
        <div className="districtCards">
          {selectedVoivodeship?.districts?.map((d: any, index: number) => (
            <DistrictCard key={index} district={d} />
          ))}
        </div>
        <div className="contact__main-info">
          <h3>Wpłacanie składek</h3>
          <p>Członkinie i członkowie Razem wpłacają składki członkowskie na konto partii.</p>

          <p>Lewica Razem</p>
          <p>{account_number}</p>
          <p>{account_address}</p>

          <h3>Wzór tytułu przelewu</h3>
          <p>XXXX SKŁADKA CZŁONKOWSKA</p>
          <p>(w miejsce XXXX wstaw indywidualny numer Twojej legitymacji członkowskiej)</p>
        </div>
      </Container>
    </main>
  );
};
